import CryptoJS from 'crypto-js'
import { salts, encryptKeyType2, saltsType3 } from './salts'
import { DEPLOY_ENV } from '@/defines/env'
import { stimeConfig } from '@/utils/stime'
import {
  getSaltIndexFromPos,
  getRandomInt,
  getSaltIndexFromPosType3
} from './utils'
import { getSource, MALL_STR, MALL_NEW_STR } from '../common_params'
import { deviceToken } from '@/defines/user'
const environment = DEPLOY_ENV

export const calcSaltSign = data => {
  const random = Math.round(Math.random() * 99)
  const timestamp = new Date().getTime()
  const env = environment === 'test' ? 'test' : 'online'
  const obj = Object.assign({}, data, {
    salt_index: random,
    time_stamp: timestamp
  })
  return `${CryptoJS.SHA256(JSON.stringify(obj) + salts[env][random])
    .toString()
    .toUpperCase()},${random},${timestamp}`
}

export const calcSaltSignType2 = data => {
  // 随机[0, 127]生成索引
  const randomSaltIndex = Math.round(Math.random() * 127)
  // 随机[0, 12]生成截取开始位置
  const randomStart = Math.round(Math.random() * 12)
  const endStart = randomStart + 3
  // 随机[randomStart + 3, 15]生成截取结束位置
  const randomEnd = getRandomInt(endStart, 15)
  // 时间戳
  const timer = new Date().getTime()
  const encyptSign = encryptKeyType2[randomSaltIndex]
    .toString()
    .substring(randomStart, randomEnd)

  const sha256String = CryptoJS.SHA256(
    encyptSign + getSource() + MALL_STR + timer
  )
    .toString()
    .substring(6)
  const saltIndex = getSaltIndexFromPos(randomSaltIndex, randomStart, randomEnd)
  return `${sha256String},2,${saltIndex},${timer}`
}

export const calcSaltSignType3 = () => {
  // 假设encryptKeyType3是一个127字符的字符串
  const keyLength = saltsType3.toString().length
  // 计算最大可能的结束位置，确保截取的字符串长度不超过16个字符
  const maxEndPos = Math.min(keyLength, 127)
  // 计算最大可能的开始位置，确保截取的字符串长度至少为3个字符
  const maxStartPos = maxEndPos - 3

  // 随机生成开始位置
  const randomStart = Math.floor(Math.random() * (maxStartPos + 1))
  // 计算最小结束位置（开始位置+3）
  const minEndPos = randomStart + 3
  // 计算最大结束位置，确保截取的字符串长度不超过16个字符
  const endPosLimit = Math.min(randomStart + 16, maxEndPos)
  // 随机生成结束位置
  const randomEnd = getRandomInt(minEndPos, endPosLimit)

  // 时间戳
  const timer = stimeConfig.getCurrentServerTime()
  // 截取密钥
  const encyptSign = saltsType3.toString().substring(randomStart, randomEnd)
  // 与请求 Header 保持一致：H5 或 Token 尚未注入时按空字符串参与验签，
  // 避免字符串拼接将 undefined 变成 "undefined"。
  const shaValue =
    encyptSign + getSource() + MALL_NEW_STR + timer + (deviceToken || '')
  const sha256String = CryptoJS.SHA256(shaValue).toString().substring(6)
  // 使用新的辅助函数生成saltIndex
  const saltIndex = getSaltIndexFromPosType3(randomStart, randomEnd)

  return `${sha256String},3,${saltIndex},${timer}`
}
